module.exports = __webpack_public_path__ + "static/img/adwdawa.2e47a97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/adwdawa.jpg
// module id = a8nF
// module chunks = 73